// @flow
import * as React from 'react';

import type { MailboxProduct } from '@gandi/cart';

import MailboxOptionRenew from './MailboxOptionRenew';

export type Props = {
  product: MailboxProduct,
};

export default function MailboxOptionRestore({
  product,
}: Props): React.MixedElement {
  return <MailboxOptionRenew product={product} />;
}
